(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7839],{

/***/ 16784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clients",
      function () {
        return __webpack_require__(85649);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ clients; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./styledComponents/Cooperation/cooperation.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-top: ",
        "px;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 94%;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 3rem 9.375rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 2.5rem;\n    line-height: 3.5rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}




const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euwlc400"
})("box-sizing:border-box;display:flex;flex-direction:column;justify-content:center;position:relative;z-index:40;width:100%;max-width:60.625rem;margin:0 auto;padding:2rem 1.5625rem;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";box-shadow:0.5rem 0.5rem 1.5rem rgba(23,0,89,0.29);border-radius:0.5rem;", (param)=>{
    let { height  } = param;
    return height && (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), -height);
}, ";", mixins/* mqMax.large */.pZ.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const ButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "euwlc401"
})("position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;justify-content:center;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "euwlc402"
})(Typography/* Header2 */.zV, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";margin:0 0 1rem 0;text-align:center;", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "euwlc403"
})(Typography/* ParagraphS */.fw, ";letter-spacing:0.0125rem;text-align:center;margin:0 0 1rem 0;");

// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./styledComponents/ButtonWithGradientHover/buttonWithGradientHover.styles.tsx
var buttonWithGradientHover_styles = __webpack_require__(46572);
;// CONCATENATED MODULE: ./styledComponents/Cooperation/Cooperation.tsx






const Cooperation = (param)=>{
    let { title , description , description2 , text , titleAs  } = param;
    const ref = (0,react.useRef)();
    const [wrapperHeight, setWrapperHeight] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        setWrapperHeight(ref.current.clientHeight);
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        ref: ref,
        height: wrapperHeight / 2,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    as: titleAs && titleAs,
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Description, {
                    children: [
                        prismic_reactjs.RichText.asText(description),
                        " ",
                        prismic_reactjs.RichText.asText(description2)
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(buttonWithGradientHover_styles/* StyledLinkButton */.U, {
                        href: routes/* Routes.EstimateProject */.Z.EstimateProject,
                        children: prismic_reactjs.RichText.asText(text)
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./styledComponents/Cooperation/index.ts

/* harmony default export */ var styledComponents_Cooperation = (Cooperation);

// EXTERNAL MODULE: ./components/sections/Hero/index.ts + 2 modules
var Hero = __webpack_require__(5650);
;// CONCATENATED MODULE: ./styles/pages/styled/clients.styles.tsx

const clients_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eu1kwo20"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");

// EXTERNAL MODULE: ./components/sections/SectionDescriptionWithImage/index.ts + 2 modules
var SectionDescriptionWithImage = __webpack_require__(21488);
// EXTERNAL MODULE: ./models/enums/titleAs.ts
var titleAs = __webpack_require__(79794);
;// CONCATENATED MODULE: ./pages/clients.tsx









const DynamicBusinessGoals = dynamic_default()(()=>__webpack_require__.e(/* import() */ 416).then(__webpack_require__.bind(__webpack_require__, 92408)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(92408)
            ]
    }
});
const DynamicReviews = dynamic_default()(()=>__webpack_require__.e(/* import() */ 4143).then(__webpack_require__.bind(__webpack_require__, 44143)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(44143)
            ]
    }
});
const DynamicTrustedBy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4575), __webpack_require__.e(6121), __webpack_require__.e(7878)]).then(__webpack_require__.bind(__webpack_require__, 9368)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9368)
            ]
    }
});
const DynamicProjects = dynamic_default()(()=>__webpack_require__.e(/* import() */ 5871).then(__webpack_require__.bind(__webpack_require__, 45871)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(45871)
            ]
    }
});
const Clients = (param)=>{
    let { data: { page  }  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(clients_styles_Wrapper, {
        className: "clients",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero/* default */.Z, {
                title: prismic_reactjs.RichText.asText(page.title),
                lottieProps: {
                    id: "clients__hero_lottie",
                    src: "https://assets10.lottiefiles.com/packages/lf20_uctf2rw6.json"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionDescriptionWithImage/* default */.Z, {
                title: prismic_reactjs.RichText.asText(page.introduction_title),
                subtitle: prismic_reactjs.RichText.asText(page.introduction_title2),
                description: prismic_reactjs.RichText.asText(page.introduction_text),
                image: page.introduction_image,
                isImageToRight: true,
                titleAs: titleAs/* TitleAs.h2 */.P.h2
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicProjects, {
                items: page.projects,
                title: prismic_reactjs.RichText.asText(page.projects_title),
                description: page.projects_description,
                titleAs: titleAs/* TitleAs.h3 */.P.h3
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicBusinessGoals, {
                data: {
                    title: prismic_reactjs.RichText.asText(page.business_title),
                    title2: prismic_reactjs.RichText.asText(page.business_title2),
                    image: page.business_image,
                    points: page.business_goals
                },
                titleAs: titleAs/* TitleAs.h4 */.P.h4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(styledComponents_Cooperation, {
                title: prismic_reactjs.RichText.asText(page.cooperation_title),
                description: page.cooperation_description,
                description2: page.cooperation_description2,
                link: page.cooperation_contact_link,
                text: page.cooperation_contact_text,
                titleAs: titleAs/* TitleAs.h5 */.P.h5
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicTrustedBy, {
                companiesTitle: prismic_reactjs.RichText.asText(page.companies_title),
                companies: page.clients_companies
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicReviews, {
                data: {
                    title: prismic_reactjs.RichText.asText(page.reviews_title),
                    title2: prismic_reactjs.RichText.asText(page.reviews_title2),
                    description: prismic_reactjs.RichText.asText(page.reviews_description),
                    clutch: prismic_reactjs.RichText.asText(page.clutch_text),
                    reviews: page.reviews
                },
                titleAs: titleAs/* TitleAs.h6 */.P.h6
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var clients = (Clients);


/***/ }),

/***/ 46572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ StyledButton; },
/* harmony export */   "U": function() { return /* binding */ StyledLinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n      max-width: unset;\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: fit-content;\n      max-width: unset;\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}



const StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "ecegdfm0"
})("position:relative;width:100%;max-width:15.1875rem;border-radius:3.75rem;padding:0.75rem 0;color:#ffffff;text-decoration:none;background-color:#0e4ed7;transition:background-color 300ms ease-in-out;text-align:center;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;cursor:pointer;border:none;", (param)=>{
    let { maxWidth  } = param;
    return maxWidth && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), maxWidth);
}, ";", (param)=>{
    let { fillButton  } = param;
    return fillButton && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, ";", (param)=>{
    let { fit  } = param;
    return fit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
}, ";&:after{content:'';box-shadow:0.5rem 0.5rem 1.5rem rgba(65,70,176,0.86);opacity:0;transition:opacity 300ms ease-in-out;display:block;height:100%;width:100%;position:absolute;top:0;left:0;border-radius:4rem;z-index:0;}&:hover{&:after{opacity:1;}}&:before{content:'';width:100%;height:100%;border-radius:3.75rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);position:absolute;top:0;left:0;z-index:-1;}&:hover{background-color:transparent;}");
const StyledLinkButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
    target: "ecegdfm1"
})("font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";position:relative;width:100%;max-width:15.1875rem;border-radius:3.75rem;padding:0.75rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-decoration:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:background-color 300ms ease-in-out;text-align:center;font-size:1.25rem;line-height:2rem;letter-spacing:0.0125rem;cursor:pointer;", (param)=>{
    let { maxWidth  } = param;
    return maxWidth && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("max-width:", maxWidth, "px;");
}, ";", (param)=>{
    let { fillButton  } = param;
    return fillButton && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:100%;max-width:unset;");
}, ";", (param)=>{
    let { fit  } = param;
    return fit && /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)("width:fit-content;max-width:unset;");
}, ";&:after{content:'';box-shadow:0.5rem 0.5rem 1.5rem rgba(65,70,176,0.86);opacity:0;transition:opacity 300ms ease-in-out;display:block;height:100%;width:100%;position:absolute;top:0;left:0;border-radius:4rem;z-index:0;}&:hover{&:after{opacity:1;}}&:before{content:'';width:100%;height:100%;border-radius:3.75rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);position:absolute;top:0;left:0;z-index:-1;}&:hover{background-color:transparent;}");


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1352,9774,2888,179], function() { return __webpack_exec__(16784); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);